import type { FlightFormLocation } from "@/app/lib/types/types";
import { array, literal, object, string } from "zod";

export const getCityName = (location: FlightFormLocation | null) => {
  if (!location) {
    return "";
  }

  return location.type === "AIRPORT" ? location.cityName : location.name;
};

export const airportSchema = object({
  id: string(),
  name: string(),
  code: string(),
  cityName: string(),
  countryName: string(),
  type: literal("AIRPORT"),
});

export const citySchema = object({
  id: string(),
  name: string(),
  code: string().optional(),
  countryName: string(),
  countryCode: string().optional(),
  type: literal("CITY"),
});

export const cityWithAirportsSchema = citySchema.extend({
  airports: array(airportSchema),
});
